import { useLanguage } from '../contexts/LanguageContext';
import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

const translations = {
    fr: frTranslations,
    en: enTranslations,
};

export const useTranslation = () => {
    const { language } = useLanguage();

    const t = (key, params = {}) => {
        const keys = key.split('.');
        let value = translations[language];

        for (const k of keys) {
            if (value && value[k]) {
                value = value[k];
            } else {
                // Fallback to French if translation not found
                value = translations.fr;
                for (const k2 of keys) {
                    if (value && value[k2]) {
                        value = value[k2];
                    } else {
                        return key; // Return key if translation not found
                    }
                }
                break;
            }
        }

        // Replace parameters if any
        if (typeof value === 'string' && params) {
            return Object.keys(params).reduce((str, param) => {
                return str.replace(`{{${param}}}`, params[param]);
            }, value);
        }

        return typeof value === 'string' ? value : key;
    };

    return { t, language };
};
